const adminMenu = [
    {
        label: "Dashboard",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "/admin/dashboard"
    },
    {
        label: "Solicitudes",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 3H16L20 7V21H4V3Z\" stroke=\"currentColor\" stroke-width=\"1.8\"/><path d=\"M8 7H16\" stroke=\"currentColor\" stroke-width=\"1.8\"/></svg>",
        href: "/admin/requests",
        children: [
            { label: "Procesar Solicitudes", href: "/admin/requests" },
            { label: "Endosos sin movimientos", href: "/admin/requests/endorsments-without-movement" },
            { label: "Endosos con movimientos", href: "/admin/requests/endorsments-with-movement" }
        ]
    },
    {
        label: "Empresa",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 21H20\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/><path d=\"M7 21V6H17V21\" stroke=\"currentColor\" stroke-width=\"2\"/><path d=\"M10 10H11M13 10H14M10 13H11M13 13H14\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/><path d=\"M11 21V17H13V21\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "/admin/companies",
        requiresNotReinsurer: true,
        children: [
            { label: "Agregar Empresa", href: "/admin/companies/new-company" },
            { label: "Agregar Contrato", href: "/admin/companies/new-contract" },
            { label: "Ver Contratos", href: "/admin/contracts" },
            { label: "Ver Empresas", href: "/admin/companies" }
        ]
    },
    {
        label: "Siniestros",        
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 3L19 6V12C19 16.5 16 19.5 12 21C8 19.5 5 16.5 5 12V6L12 3Z\" stroke=\"currentColor\" stroke-width=\"2\"/><path d=\"M12 8V12\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/><circle cx=\"12\" cy=\"15\" r=\"1\" fill=\"currentColor\"/></svg>",
        href: "/admin/claims",
        children: [
            { label: "Procesar Siniestros", href: "/admin/claims" },
            { label: "Procesar pagos", href: "/admin/claimspayments" }
        ]
    },
    {
        label: "Batches",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 4L20 8L12 12L4 8L12 4Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\"/><path d=\"M4 12L12 16L20 12\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M4 16L12 20L20 16\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>",
        href: "/admin/batches",
        children: [
            { label: "Crear Batch", href: "/admin/batches/new" },
            { label: "Ver Batches", href: "/admin/batches" }
        ]
    },
    {
        label: "Cierre trimestral",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2v20M5 7h14M5 17h14\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "#",
        children: [
            { label: "Reporte de siniestros avisados", action: "exportReportedClaims" },
            { label: "Reporte de solicitudes", action: "exportRequests" },
            { label: "Reporte de solicitudes por zonas de cúmulo", href: "/admin/control-zones-requests-report" },
            { label: "Borderaux de siniestros", action: "exportBorderaux" }
        ]
    },
    {
        label: "Generales",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12\" r=\"3\" stroke=\"currentColor\" stroke-width=\"2\"/><path d=\"M12 2V5M12 19V22M22 12H19M5 12H2M19.07 4.93L16.95 7.05M7.05 16.95L4.93 19.07M19.07 19.07L16.95 16.95M7.05 7.05L4.93 4.93\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></svg>",
        href: "/admin/generals",
        requiresNotReinsurer: true
    },
    {
        label: "Monedas",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 3V21\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/><path d=\"M16 7C16 5.34 14.21 4 12 4C9.79 4 8 5.34 8 7C8 8.66 9.79 10 12 10C14.21 10 16 11.34 16 13C16 14.66 14.21 16 12 16C9.79 16 8 14.66 8 13\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></svg>",
        href: "/admin/exchanges",
        requiresNotReinsurer: true
    },
    {
        label: "Reaseguradores",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"5\" r=\"2\" stroke=\"currentColor\" stroke-width=\"2\"/><circle cx=\"5\" cy=\"19\" r=\"2\" stroke=\"currentColor\" stroke-width=\"2\"/><circle cx=\"19\" cy=\"19\" r=\"2\" stroke=\"currentColor\" stroke-width=\"2\"/><path d=\"M12 7V12M12 12L6.5 17M12 12L17.5 17\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/></svg>",
        href: "/admin/reinsurers",
        requiresNotReinsurer: true
    },
    {
        label: "Usuarios",
        icon: "<svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"8\" r=\"4\" stroke=\"currentColor\" stroke-width=\"2\"/><path d=\"M4 20c0-4 16-4 16 0\" stroke=\"currentColor\" stroke-width=\"2\"/></svg>",
        href: "/admin/users",
        requiresNotReinsurer: true
    }
];

export default adminMenu;